import { render, staticRenderFns } from "./resultUser.vue?vue&type=template&id=3137caa7&scoped=true&"
import script from "./resultUser.vue?vue&type=script&lang=js&"
export * from "./resultUser.vue?vue&type=script&lang=js&"
import style0 from "./resultUser.vue?vue&type=style&index=0&id=3137caa7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137caa7",
  null
  
)

export default component.exports